import { Mail, User, Calendar } from 'lucide-react'

type Props = {
  user: {
    name: string
    email: string
    date_joined: string
    avatar_url?: string
  }
}

const UserInfoCard: React.FC<Props> = ({ user }) => {
  return (
    <div className="w-full max-w-md p-6 bg-white shadow-xl rounded-2xl border border-gray-200 mt-6">
      <h2 className="text-2xl font-bold text-gray-800 mb-4">👤 Minhas informações</h2>
      <div className="flex-shrink-0">
        {user.avatar_url ? (
          <img
            src={user.avatar_url}
            alt={`Avatar de ${user.name}`}
            className="w-20 h-20 rounded-full object-cover border border-gray-300 shadow-sm"
          />
        ) : (
          <div className="w-20 h-20 rounded-full bg-blue-100 border border-gray-300 shadow-sm flex items-center justify-center text-blue-600 text-3xl font-bold uppercase">
            {user.name?.charAt(0)}
          </div>
        )}
      </div>
      <div className="mt-6 text-sm text-gray-600 italic">
        <User className="text-blue-500 w-5 h-5" />
        <p className="text-sm text-gray-600">Nome</p>
        <p className="text-gray-800 font-medium">{user.name}</p>
      </div>
      <div className="mt-2 text-sm text-gray-600">
        <p className="text-sm text-gray-600">Membro desde</p>
          <p className="text-gray-800 font-medium">
            {new Date(user.date_joined).toLocaleDateString('pt-BR')}
          </p>
          <p>
            <span className="text-sm text-gray-500">{user.email}</span>
          </p>
      </div>
    </div>
  )
}

export default UserInfoCard
